export class Banner {
    nodeEl = '.js-new-site';
    overlayEl = '.js-new-site-overlay';
    closeEl = '.js-new-site-close'

    init = () => {
        setTimeout(()=>{
            this.node.css({'display': 'flex', 'opacity': '0'});
            this.node.animate({'opacity': 1}, 300);
        }, 1000)
    }

    onClose = () => {
        this.node.animate({'opacity': 0}, 300, ()=> {
            this.node.css({'display': 'none'});
        });
    }

    constructor() {
        this.node = $(this.nodeEl);
        this.close =  $(this.closeEl);
        this.overlay = $(this.overlayEl);

        this.overlay.on('click', this.onClose);
        this.close.on('click', this.onClose);

        this.init();
    }
}



// WEBPACK FOOTER //
// ./app/blocks/new-site/new-site.js